import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { Locale } from 'vant';
import moment from 'moment';
// 引入英文语言包
import vantEn from 'vant/es/locale/lang/en-US';
import vantZh from 'vant/es/locale/lang/zh-CN';

const en = require.context('./en', false, /\.json/);
const zh = require.context('./zh', false, /\.json/);

export const DEFAULT_LANG = ''; // window.navigator.language.includes('zh');
const locale = DEFAULT_LANG ? 'zh-cn' : 'en';

// Vue.prototype.$moment = moment;
if (DEFAULT_LANG) {
  Locale.use('zh-CN', vantZh);
} else {
  Locale.use('en-US', vantEn);
}

moment.locale(locale);

Vue.prototype.$moment = moment;
Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale,
  // 数字格式化
  numberFormats: {
    en: {
      currency: {
        style: 'currency',
        currency: 'USD'
      }
    },
    zh: {
      currency: {
        style: 'currency',
        currency: 'CNY'
      }
    }
  },
  messages: {
    en: getLocaleMsg(en),
    zh: getLocaleMsg(zh)
  }
})

function getLocaleMsg(locales) {
  const localList = {};
  locales.keys().forEach((key) => {
    const reg = /\.\/(.*?)\.json/g;
    const keyName = reg.exec(key)[1];
    Object.assign(localList, {
      [keyName]: locales(key),
    });
  });

  return localList;
}
